import React from 'react';
import BasicMeta from '../BasicMeta';

const descriptions = {
  se: {
    description: 'Se vad som visas på Viasats TV-kanalen. Viasat fotboll, Viasat Premium, Viasat Sport, Viasat Hockey, Viasat Golf, Viasat Motor. ',
    title: 'TV-guide',
  },
  no: {
    description: 'Se hva som vises på Viasat Fotball, Viasat Sport med vår TV-guide.',
    title: 'TV-guide',
  },
  dk: {
    description: 'Få overblik og sendetider for sport på TV. TV3+, TV3 Sport 1, TV3 Sport 2 og Viasat Golf.',
    title: 'TV-guide',
  },
  fi: {
    description: 'Ohjelmatiedot, Viasat Urheilu, Viasat Jääkiekko, Viasat Jalkapallo, Viasat Sport, Viasat Hockey',
    title: 'Ohjelmaopas',
  },
};

export default class TvGuideMeta extends React.PureComponent {
  render() {
    return (
       <BasicMeta descriptions={descriptions} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/TvGuide/TvGuideMeta.jsx